<template>
  <div>
    <el-dialog title="Chọn loại chữ ký số" :visible.sync="isOpen" width="500px" :before-close="handleClose" :close-on-click-modal="false">
      <div class="flex flex-col gap-1">
        <div class="text-sm text-gray-600 mb-3">
          Vui lòng chọn loại chữ ký số mà bạn muốn đăng ký:
        </div>
        <div
          @click="selectType('personal')"
          :class="[
            'border-2 rounded-lg p-3 cursor-pointer transition-all',
            selectedType === 'personal'
              ? 'border-blue-600 bg-blue-50'
              : 'border-gray-200 hover:border-blue-500 hover:bg-blue-50 bg-gray-50'
          ]"
        >
          <div class="flex items-start gap-3">
            <div>
              <div class="font-semibold text-gray-800">Cá nhân</div>
              <div class="text-sm text-gray-600 mt-1">Chứ ký số cho cá nhân làm việc độc lập hoặc không đại diện tổ chức</div>
            </div>
          </div>
        </div>

        <div
          @click="selectType('organization')"
          :class="[
            'border-2 rounded-lg p-3 cursor-pointer transition-all',
            selectedType === 'organization'
              ? 'border-blue-600 bg-blue-50'
              : 'border-gray-200 hover:border-blue-500 hover:bg-blue-50 bg-gray-50'
          ]"
        >
          <div class="flex items-start gap-3">
            <div>
              <div class="font-semibold text-gray-800">Cá nhân thuộc tổ chức</div>
              <div class="text-sm text-gray-600 mt-1">Chứ ký số cho nhân viên/ đại diện của công ty, tổ chức</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Hủy</el-button>
        <el-button type="primary" @click="handleConfirm" :disabled="!selectedType">Tiếp tục</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ModalSelectCertType',
  data () {
    return {
      isOpen: false,
      selectedType: '' // 'personal' or 'organization'
    }
  },
  methods: {
    handleOpen () {
      this.isOpen = true
      this.selectedType = ''
    },
    handleClose () {
      this.isOpen = false
      this.selectedType = ''
    },
    selectType (type) {
      this.selectedType = type
    },
    handleConfirm () {
      this.$emit('onTypeSelected', this.selectedType)
      this.handleClose()
    }
  }
}
</script>

<style scoped>
::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
}

::v-deep .el-dialog__footer {
  padding: 10px 20px 20px;
  border-top: 1px solid #f0f0f0;
}
</style>
